'use strict'

export default [() => {
    return {
        templateUrl: '/partial/app.partials.dashboard.broadcast_intermezzo',
        replace: true,
        controller: [
            '$scope',
            '$state',
            ($scope, $state) => {
                $scope.goToBroadcast = () => {
                    const broadcast = $scope.broadcast

                    if (broadcast.masterstation_id) {
                        $state.go('rundown', {
                            broadcast: broadcast.slavebroadcast_id,
                            program: broadcast.program_id,
                            externalBroadcastId: broadcast.id
                        })
                    } else {
                        $state.go('rundown', {
                            broadcast: broadcast.id,
                            program: broadcast.program_id
                        })
                    }
                }
            },
        ],
        scope: {
            broadcast: '=',
        },
    }
}]
